import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
type Props = {
  className?: string
}

export const FaqContent = ({ className }: Props) => {
  const t = useTranslations('account_page.faq')

  return (
    <Accordion type='multiple' className='flex w-full flex-col gap-3'>
      {Array.from({ length: 10 }).map((_, index) => (
        <AccordionItem
          value={index.toString()}
          key={index}
          className={cn(
            'rounded-lg border-0 bg-neutral-100 px-6 py-3',
            className
          )}
        >
          <AccordionTrigger
            className='py-0 text-left font-sans text-base font-normal leading-5 text-neutral-800 no-underline hover:no-underline'
            hasPlusIcon
          >
            {t(`${index}.title`)}
          </AccordionTrigger>
          <AccordionContent className='mt-2 whitespace-pre-line border-t border-t-neutral-900/30 pb-0 pt-2 font-sans text-base font-normal leading-5 text-neutral-900/70'>
            {t.rich(`${index}.description`, {
              strong: (children) => <strong>{children}</strong>,
            })}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
